export default __webpack_public_path__ + "static/media/logo-gnosis.6b84eb0c.png";